<div class="grid grid-cols-1 md:grid-cols-2 gap-8 w-full mt-8">
    <!-- Earned $ -->
    <div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden">
        <div class="flex items-start justify-between mx-6 mt-3 mb-0">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">Earned Amount $</div>
        </div>
        <div class="flex flex-col mx-6 mt-3">
            <div class="text-4xl font-bold tracking-tighter leading-tight">{{totalEarnedFiat | currency}}</div>
        </div>
        <div class="flex flex-col flex-auto">
            <apx-chart *ngIf="earnedChart$" class="flex-auto w-full h-full" [chart]="earnedChart$.chart"
                [colors]="earnedChart$.colors" [series]="earnedChart$.series" [stroke]="earnedChart$.stroke"
                [tooltip]="earnedChart$.tooltip" [xaxis]="earnedChart$.xaxis">
            </apx-chart>
        </div>
    </div>
    <!-- Earned Matic -->
    <div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden">
        <div class="flex items-start justify-between mx-6 mt-3 mb-0">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">Earned Amount Matic</div>
        </div>
        <div class="flex flex-col mx-6 mt-3">
            <div class="text-4xl font-bold tracking-tighter leading-tight">
                <p class="flex items-center gap-x-2">
                    {{totalEarnedCrypto | number:'1.0-4'}}
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" viewBox="0 0 256 256"
                        fill="none">
                        <path
                            d="M186.384 171.561L243.497 138.588C246.518 136.842 248.397 133.591 248.397 130.099V64.1433C248.397 60.6566 246.518 57.4003 243.497 55.6543L186.384 22.6815C183.363 20.9356 179.605 20.9407 176.584 22.6815L119.47 55.6543C116.45 57.4003 114.571 60.6515 114.571 64.1433V182.001L74.5219 205.117L34.4733 182.001V135.752L74.5219 112.635L100.941 127.882V96.8601L79.4218 84.439C77.937 83.5839 76.2422 83.1334 74.5219 83.1334C72.8016 83.1334 71.1069 83.5839 69.6221 84.439L12.5034 117.417C9.48256 119.163 7.60352 122.414 7.60352 125.906V191.857C7.60352 195.343 9.48256 198.6 12.5034 200.346L69.617 233.323C72.6378 235.064 76.3907 235.064 79.4166 233.323L136.53 200.351C139.551 198.605 141.43 195.348 141.43 191.862V74.0044L142.152 73.5897L181.479 50.8876L221.527 74.0095V120.253L181.479 143.375L155.1 128.148V159.171L176.579 171.576C179.6 173.317 183.358 173.317 186.379 171.576L186.384 171.561Z"
                            fill="url(#paint0_linear_4864_1937)" />
                        <defs>
                            <linearGradient id="paint0_linear_4864_1937" x1="28.0733" y1="200.863" x2="235.024"
                                y2="49.9609" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#A726C1" />
                                <stop offset="0.88" stop-color="#803BDF" />
                                <stop offset="1" stop-color="#7B3FE4" />
                            </linearGradient>
                        </defs>
                    </svg>
                </p>
            </div>
        </div>
        <div class="flex flex-col flex-auto">
            <apx-chart *ngIf="earnedChartMatic" class="flex-auto w-full h-full" [chart]="earnedChartMatic.chart"
                [colors]="earnedChartMatic.colors" [series]="earnedChartMatic.series" [stroke]="earnedChartMatic.stroke"
                [tooltip]="earnedChartMatic.tooltip" [xaxis]="earnedChartMatic.xaxis">
            </apx-chart>
        </div>
    </div>
    <!-- Token -->
    <div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden">
        <div class="flex items-start justify-between mx-6 mt-3 mb-0">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">Packs Sold</div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center mx-6 mt-3">
            <div class="text-7xl font-bold tracking-tighter leading-tight">{{totalPacks}}</div>
        </div>
        <div class="flex flex-col flex-auto">
            <apx-chart *ngIf="packChart" class="flex-auto w-full h-full" [chart]="packChart.chart"
                [colors]="packChart.colors" [series]="packChart.series" [stroke]="packChart.stroke"
                [tooltip]="packChart.tooltip" [xaxis]="packChart.xaxis">
            </apx-chart>
        </div>
    </div>
    <!-- SOLD -->
    <div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden">
        <div class="flex items-start justify-between mx-6 mt-3 mb-0">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">Collectibles Sold</div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center mx-6 mt-3">
            <div class="text-7xl font-bold tracking-tighter leading-tight">{{totalSold | number:'1.0-0'}}</div>
        </div>
        <div class="flex flex-col flex-auto">
            <apx-chart *ngIf="soldChart" class="flex-auto w-full h-full" [chart]="soldChart.chart"
                [colors]="soldChart.colors" [series]="soldChart.series" [stroke]="soldChart.stroke"
                [tooltip]="soldChart.tooltip" [xaxis]="soldChart.xaxis">
            </apx-chart>
        </div>
    </div>
</div>